function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fence_stroke{fill:none;stroke:#aa39e5;stroke-miterlimit:10;stroke-opacity:0.5;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "fence"
}, /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 1.5,
  y1: 4.5,
  x2: 9.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 12.5,
  y1: 4.5,
  x2: 20.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "fence_stroke",
  cx: 26.5,
  cy: 4.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 32.5,
  y1: 4.5,
  x2: 40.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 43.5,
  y1: 4.5,
  x2: 51.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 54.5,
  y1: 4.5,
  x2: 62.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "fence_stroke",
  cx: 68.5,
  cy: 4.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 74.5,
  y1: 4.5,
  x2: 82.5,
  y2: 4.5
}), /*#__PURE__*/React.createElement("line", {
  className: "fence_stroke",
  x1: 85.5,
  y1: 4.5,
  x2: 93.5,
  y2: 4.5
}));

var SvgFence = function SvgFence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fenceIcon",
    viewBox: "0 0 95 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fence.2bca317f.svg";
export { ForwardRef as ReactComponent };